export default __webpack_public_path__ + "static/media/companies-importation-template.867d6835.xlsx";